import _ from 'underscore'
import { isLoadedLocally } from '@/common/util/url'

export default class Communicator {
  constructor(application, locator) {
    this.source = application
    this.$locator = locator
    this.listeners = []

    this.init()
  }

  /**
   * Bootstrap method of the class. Will create the method
   * that will report all listeners the messages received from
   * other iframes
   */
  init() {
    window.addEventListener(
      'message',
      e => {
        this.listeners.forEach(listener => {
          listener(e.data)
        })
      },
      false
    )
  }

  /**
   * Adds a listener to the received messages from the iframes
   *
   * @param {Function} listener Listener method
   */
  addListener(listener) {
    // Only 1 listener allowed
    if (_.isFunction(listener)) this.listeners = [listener]
  }

  /**
   * Sends a message through the IFrame (parent or children)
   *
   * @param {string} msg Message to send
   * @param {object} options Options to send the message
   * @param {boolean} options.toChildWin If true, sends the message to the child window (redirect)
   * @param {string} options.delegate List of delegated capabilities (space separated)
   * @param {boolean} options.allowWithoutUserInteraction If true, allows sending messages without user interaction (e.g., for Google Pay SDK setup)
   * @param {string} options.paymentMethod The payment method related to the message, used for conditional logic (e.g., 'GOOGLEPAY')
   */
  send(msg, options = {}) {
    const { toChildWin } = options
    if (this.source === 'host') {
      if (!isLoadedLocally(window.location.href)) {
        if (toChildWin) this.sendToWindow(msg)
        else this.sendToIframe(msg, options)
      }
    } else {
      let target = window.parent // Iframe
      if (window.opener) target = window.opener // Window
      if (target && window.FIELD_CONFIGURATION) {
        if (!isLoadedLocally(window.FIELD_CONFIGURATION.parentDomain)) {
          target.postMessage(msg, window.FIELD_CONFIGURATION.parentDomain)
        }
      }
    }
  }

  /**
   * Sends the message to the ghost
   *
   * @param {*} msg
   * @param {string} delegate List of delegated capabilities (space separated)
   * @see KJS-4106 | Removed Zepto and access ghost through iframeController
   */
  sendToIframe(msg, options = {}) {
    const ghost = this.$locator.iframeController.ghostContainer
    if (!ghost) return

    ghost.postMessage(msg, options)
  }

  /**
   * Sends the message to the window (redirect)
   *
   * @param {*} msg
   */
  sendToWindow(msg) {
    const targetWin = window.redirectionWindow
    const { baseAddress } = this.$locator.$store.state

    targetWin.postMessage(msg, `${baseAddress}/redirect/redirect.html`)
  }
}
